<template>
  <ams-select-table
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :pre_selected_items="pre_selection"
    :select_mode="mode_selection"
    @selectedRows="selectRows"
  />
</template>

<script>
import AmsSelectTable from './AmsSelectTable.vue'

export default {
  components: {
    AmsSelectTable
  },
  props: {
    pre_selection: {
      Type: Array
    }
  },
  data() {
    return {
      mode_selection: 'single',
      ams_type: 'product-items',
      ams_api_path: 'api/admin/v1',
      ams_fields: [
       { 
          key: 'attributes.serial-number',
          label: 'Serial',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc' 
        },
        {
          key: 'attributes.purchased-price-cents',
          label: 'Purchased Price',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc'
        },
       { 
          key: 'attributes.description',
          label: 'Description',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
      ]
    }
  },
  methods: {
    selectRows(items) {
      this.$emit('selectedItems', items)
    }
  }
}
</script>